import React from 'react';

const Services = () => {
  const services = [
    {
      icon: 'fa-wifi',
      title: 'High-Speed Internet',
      description: 'Experience lightning-fast fiber optic internet with speeds up to 1Gbps for seamless browsing, streaming, and gaming.',
      gradient: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)'
    },
    {
      icon: 'fa-tv',
      title: 'IPTV Services',
      description: 'Enjoy crystal clear digital TV with hundreds of HD channels, on-demand content, and premium sports packages.',
      gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)'
    },
    {
      icon: 'fa-phone-volume',
      title: 'Digital Phone',
      description: 'Crystal clear voice quality with unlimited local and international calling plans at competitive rates.',
      gradient: 'linear-gradient(135deg, #a8ff78 0%, #78ffd6 100%)'
    },
    {
      icon: 'fa-shield-alt',
      title: 'Cyber Security',
      description: 'Advanced security solutions including antivirus, firewall protection, and secure browsing for all your devices.',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    },
    {
      icon: 'fa-network-wired',
      title: 'Business Solutions',
      description: 'Tailored internet and networking solutions with dedicated support and guaranteed uptime for your business.',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    },
    {
      icon: 'fa-headset',
      title: '24/7 Support',
      description: 'Round-the-clock technical support from our team of experts to ensure uninterrupted service.',
      gradient: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)'
    }
  ];

  return (
    <section id="services" className="services py-5 position-relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="position-absolute top-0 start-0 w-100 h-100">
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-light opacity-10"></div>
        <div className="position-absolute top-0 end-0 w-50 h-50 bg-primary rounded-circle opacity-10" style={{
          transform: 'translate(25%, -25%)',
          filter: 'blur(80px)'
        }}></div>
      </div>
      
      <div className="container position-relative">
        <div className="text-center mb-5" data-aos="fade-up">
          <span className="text-primary fw-bold d-block mb-2">OUR SERVICES</span>
          <h2 className="display-5 fw-bold mb-3">Connect to What Matters Most</h2>
          <p className="lead text-muted max-w-3xl mx-auto">Experience the next generation of internet services with our comprehensive solutions designed for both home and business needs.</p>
        </div>
        
        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-lg-4 col-md-6" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
              <div className="card h-100 border-0 shadow-hover-lg transition-all" style={{
                borderRadius: '15px',
                overflow: 'hidden',
                transition: 'all 0.3s ease-in-out'
              }}>
                <div className="position-relative">
                  <div className="position-absolute top-0 start-0 w-100 h-100" style={{
                    background: service.color,
                    opacity: 0.1
                  }}></div>
                  <div className="icon-box mx-auto mt-4" style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: service.gradient,
                    color: 'white',
                    fontSize: '2rem',
                    marginBottom: '1.5rem',
                    position: 'relative',
                    zIndex: 1,
                    boxShadow: '0 10px 30px -5px rgba(0,0,0,0.1)'
                  }}>
                    <i className={`fas ${service.icon}`}></i>
                  </div>
                </div>
                
                <div className="card-body text-center p-4 pt-0">
                  <h3 className="h4 mb-3 fw-bold" style={{
                    background: service.gradient,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    display: 'inline-block'
                  }}>{service.title}</h3>
                  <p className="text-muted mb-4">{service.description}</p>
                  <a href="#contact" className="btn btn-sm btn-outline-primary px-4 py-2 rounded-pill fw-medium">
                    Learn More <i className="fas fa-arrow-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-5" data-aos="fade-up">
          <p className="mb-4">Not sure which service is right for you?</p>
          <a href="#contact" className="btn btn-primary btn-lg px-5 py-3 rounded-pill fw-medium">
            Get a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
